import gql from 'graphql-tag';
import CommonEncounter from '../fragments/encounter';
import CommonSimpleFacility from '../fragments/simpleFacility';

export default gql`
  query ProviderEncounters {
    providerEncounters {
      nodes {
        ...CommonEncounter
        facility {
          ...CommonSimpleFacility
        }
      }
      totalCount
    }
  }
  ${CommonEncounter}
  ${CommonSimpleFacility}
`;
